import { useAppDispatch, useAppSelector } from '@app/hooks';
import { BaseSegmentedControl, type SegmentOption } from '@shared/components/base';

import { SHELL_TEXT } from '../constants';
import { type ThemeMode } from '../theme';
import { selectThemeMode, setThemeMode } from '../uiSlice';

const OPTIONS: readonly SegmentOption<ThemeMode>[] = [
  { label: SHELL_TEXT.theme.light, value: 'light' },
  { label: SHELL_TEXT.theme.dark, value: 'dark' },
  { label: SHELL_TEXT.theme.auto, value: 'auto' },
];

export function ThemeSwitch() {
  const mode = useAppSelector(selectThemeMode);
  const dispatch = useAppDispatch();
  return (
    <BaseSegmentedControl
      aria-label={SHELL_TEXT.theme.label}
      value={mode}
      options={OPTIONS}
      onChange={(m) => dispatch(setThemeMode(m))}
    />
  );
}
